import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { Avatar } from "@mui/material";

interface IProps {
  name: string;
}

function FileInputAvatar({ name }: IProps) {
  const { values }: any = useFormikContext();
  const [fileURL, setFileURL] = useState(values[name]);

  useEffect(() => {
    setFileURL(values[name]);
  }, [values[name]]);

  useEffect(() => {
    setFileURL(values[name]);
  }, []);

  return (
    <Avatar
      alt="Profile Picture"
      src={fileURL ? window?.URL?.createObjectURL(fileURL) : ""}
      sx={{ width: 171, height: 171 }}
    />
  );
}

export default FileInputAvatar;
